<template>
  <v-row density="compact">
    <p>
      KAMA adjusts as price swings widen and can be used to identify changes in trend. Short KAMA
      uses 10 trading days for the efficiency ratio, 2 days for the fastest EMA and 30 days for the
      slowest EMA. Long KAMA uses 10 trading days for the efficiency ratio, 5 days for the fastest
      EMA and 30 days for the slowest EMA
    </p>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.term"
        :items="['long', 'short']"
        label="Long or Short Term KAMA"
        hint="Long or Short-Term KAMA"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('term', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.above_below"
        :items="['above', 'below']"
        label="Current Price Above or Below KAMA"
        hint="Current Price Above or Below KAMA"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.consecutive_days"
        density="compact"
        hide-details
        variant="outlined"
        label="Consecutive days price has been above or below KAMA"
        @update:model-value="updateConfig('consecutive_days', $event)"
      />
    </v-col>

    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.percent"
        density="compact"
        hide-details
        variant="outlined"
        label="% Closing price above or below KAMA"
        hint="Closing Price % Above or Below KAMA"
        @update:model-value="updateConfig('percent', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      editedTa: {
        enabled: true,
        above_below: 'above',
        term: 'short',
        rule_type: 'kama',
        consecutive_days: 5,
        percent: 3,
        long_short: 'long'
      },
      defaultTa: {
        enabled: true,
        above_below: 'above',
        term: 'short',
        rule_type: 'kama',
        consecutive_days: 5,
        percent: 3,
        long_short: 'long'
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'kama') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
